import { render } from "./drop_header.vue?vue&type=template&id=c12e0cb4&ts=true"
import script from "./drop_header.vue?vue&type=script&lang=ts"
export * from "./drop_header.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__